var v1="<div class=\"lbaLatLngMap\"> <label>{{ vm.settings.displayName }}</label> <div class=\"lbaLatLngMap_map\" ng-attr-id=\"{{vm.mapId}}\"></div> <div><button class=\"btn btn-default lbaLatLng_toggle\" ng-click=\"vm.toggleLabels()\">Toggle labels/pins</button></div> </div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("components/lbaLatLngMap/lbaLatLngMap.html", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbaLatLngMap/lbaLatLngMap.html
// module id = 392
// module chunks = 0